import React from 'react';

import classNames from 'classnames';
import ChevronRightIcon from 'icons/chevron-right.svg';
import FoldersIcon from 'icons/folders.svg';
import PropTypes from 'prop-types';

export default function SelectionRow({
  childCount,
  content,
  isSelected,
  onSelection,
  onTraversal,
  showTraverse,
}) {
  return (
    <div
      className={classNames(
        'row-bar handshq--hoverable b-l-none b-r-none b-t-none tw-group/row tw-border-grey-100 tw-pt-px hover:tw-bg-blue-025',
        isSelected ? 'tw-bg-blue-025' : 'tw-bg-white',
      )}
      onClick={onSelection}
    >
      <div
        className='row-bar__content'
        data-element-name='selection-row-content'
      >
        <span className='tw-truncate tw-text-grey-900'>{content}</span>
      </div>
      <div className='row-bar__actions'>
        {childCount > 0 && (
          <span
            className='tw-mr-4 tw-flex tw-items-center tw-text-s tw-text-grey-700'
            data-element-name='selection-row-child-count'
          >
            <FoldersIcon
              className='[&_path]:tw-fill-grey-700'
              height={16}
              width={16}
            />
            <span className='tw-ml-1'>{childCount}</span>
          </span>
        )}
        {showTraverse && (
          <span
            className={classNames(
              'tw-flex tw-rounded-sm tw-border-1 tw-border-solid tw-bg-white group-hover/row:tw-border-grey-100',
              isSelected ? 'tw-border-grey-100' : 'tw-border-white',
            )}
            data-element-name='selection-row-traverse'
            onClick={(e) => {
              if (!onTraversal) return undefined;

              e.stopPropagation();
              onTraversal();
            }}
          >
            <ChevronRightIcon className='[&_polygon]:tw-fill-grey-700' />
          </span>
        )}
      </div>
    </div>
  );
}

SelectionRow.propTypes = {
  content: PropTypes.any,
  showTraverse: PropTypes.bool,
  onSelection: PropTypes.func,
  onTraversal: PropTypes.func,
  isSelected: PropTypes.bool,
  childCount: PropTypes.number,
};
